// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__eGdFG","left":"StickyBox_left__3r8yV","right":"StickyBox_right__3C-4B"};